const VERTICAL_IDS = {
  SEO_BLOG_ARTICLE: 20,
  WEBSITE_CONTENT: 21,
  ACADEMIC: 22,
  COMPLETE_BOOK: 23,
  PRESS_RELEASE: 24,
  ECOMMERCE_CONTENT: 25,
  WHITE_PAPER: 26,
  BRANDED_CONTENT: 27,
  COPYWRITING: 28,
  THOUGHT_LEADERSHIP_CONTENT: 29,
  LINKED_IN_PROFILE: 30,
  SOCIAL_MEDIA_CONTENT: 31,
  PRODUCT_DESCRIPTION: 32,
  TESTIMONIALS_REVIEW: 33,
  COMPANY_PROFILE: 34,
  TECHNICAL_DOCUMENTATION: 35,
  NEWSLETTER_DOCUMENT: 36,
  EMAIL: 37,
  EBOOK: 38,
  PORTFOLIO_PRESENTATION: 39,
  RESUME: 40,
  SCRIPTWRITING: 41,
  TRANSLATION: 42,
  COVER_LETTER: 43,
  CASE_STUDY: 44,
  IN_APP_CONTENT_TRANSLATION: 45,
  OTHERS: 46,
  APP_LOCALISATION: 47,
  FORMS_AND_QUESTIONNAIRE: 48,
  BLOG_ARTICLE_TRANSLATION: 49,
  SINGLE_POST: 52,
  GIF: 53,
  WEBSITE_AND_ECOMMERCE_AD: 54,
  DISPLAY_AD: 55,
  INFOGRAPHIC: 56,
  WHITEPAPER_EBOOK_DOCUMENT: 57,
  PRESENTATION: 58,
  LOGO: 59,
  IMAGE_RETOUCH: 60,
  BLOG_IMAGE: 62,
  ADAPTS: 64,
  DRIP_PROMOTIONAL_EMAIL: 65,
  TECHNICAL_ILLUSTRATION: 66,
  MENU_DESIGN: 67,
  BROCHURE: 68,
  OTHER_DESIGN: 69,
  OTHER: 97,
  IN_DEPTH_BLOG: 98,
  AI_WRITTEN_PRODUCT_DESCRIPTION: 99,
  IN_APP_CONTENT: 100,
  CAROUSEL_POST: 101,
  STORY_POST: 102,
  RICH_PRODUCT_DESCRIPTION: 103,
  SPECIALISED_TRANSLATION: 104,
  MULTILINGUAL_COPYWRITING: 105,
  MULTILINGUAL_CONTENT_CREATION: 106,
  DOCUMENT_TRANSCREATION: 107,
  SCRIPT_TRANSCREATION: 108,
  WEBSITE_LOCALISATION: 109,
  SUBTITLE_CAPTION: 110,
  TRANSCRIPTION: 111,
  SEO_WEBPAGE: 112,
  SEO_FOOTER_CONTENT: 113,
  ABOUT_US_AND_BIO_PAGE: 114,
  PUSH_NOTIFICATION: 115,
  NEWSLETTER: 116,
  SHORT_FORM_TRANSLATION: 129
}

export default VERTICAL_IDS
